<template>
  <mdb-container class="gp-has-header">
    <div v-if="showMain">
      <mdb-card class="text-left mb-4">
        <mdb-card-header v-if="showAdminButtons" class="text-right secondary-color text-white">
          <mdb-btn size="sm" floating tag="a"
                   label="Edit Page" title="Edit Page"
                   aria-label="Edit Page"
                   v-show="affiliate.authority.editLandingPage"
                   rounded icon="pencil" @click="editPage">
          </mdb-btn>
          <mdb-btn size="sm" floating tag="a"
                   label="Access" title="Access"
                   aria-label="Access"
                   v-show="affiliate.authority.userMaint"
                   rounded icon="users" @click="userMaint">
          </mdb-btn>
        </mdb-card-header>
        <mdb-card-body>
          <div v-html="affiliate.homeHtml"></div>
        </mdb-card-body>
        <!-- <mdb-card-footer v-if="!loggedIn">
          <mdb-btn @click="$router.push('/register')" icon="user-plus">Register Now</mdb-btn>
        </mdb-card-footer>
        -->
      </mdb-card>

      <mdb-card v-if="affiliate && affiliate.groups && affiliate.groups.length>0">
        <mdb-card-header class="secondary-color text-white">
          <h2>Our Groups</h2>
        </mdb-card-header>
        <mdb-card-body>

          <mdb-row>
            <div v-for="(g,i) in affiliate.groups" :key="i" class="col-lg-3 col-md-12 m-auto">
              <a href="" @click.prevent="$router.push(g.url)">
                <mdb-card class="mb-4" ecommerce narrow style="min-height: 400px;">
                  <mdb-view cascade hover>
                    <mdb-card-image :alt="g.name + ' avatar'" :src="g.avatar"
                                    style="background-color: #ffffff;"
                                    top
                                    waves
                    ></mdb-card-image>

                    <mdb-mask flex-center overlay="white-slight" waves></mdb-mask>

                  </mdb-view>
                  <mdb-card-body cascade>
                    <div>{{ g.name }}</div>
                    <div>{{ g.city ? g.city : '&nbsp;' }}</div>
                    <div style="position: absolute; bottom: 0; right: 0;">
                      <mdb-badge>{{ g.members }} {{ g.memberLabel }}</mdb-badge>
                    </div>
                  </mdb-card-body>
                </mdb-card>
              </a>
            </div>
          </mdb-row>
        </mdb-card-body>
      </mdb-card>
    </div>

    <edit-page :affiliate="affiliate" v-if="showPageEdit" @cancel="cancelEdit" @saved="pageSaved"/>
    <user-maint :affiliate="affiliate" v-if="showUserMaint" @cancel="cancelUserMaint"/>

  </mdb-container>
</template>

<script>
import api from '../../services/groupsPlaceApi.js'
import {
  mdbBadge,
  mdbBtn,
  mdbCard,
  mdbCardBody,
  mdbCardFooter,
  mdbCardHeader,
  mdbCardImage,
  mdbCardText,
  mdbCardTitle,
  mdbCol,
  mdbContainer,
  mdbMask,
  mdbRow,
  mdbView,
} from 'mdbvue';
import EditPage from "./EditPage";
import UserMaint from "./UserMaint";

export default {
  name: 'affiliate-home-viewer',
  components: {
    mdbContainer,
    mdbCard,
    mdbCardHeader,
    mdbCardBody,
    mdbCardTitle,
    mdbCardText,
    mdbRow,
    mdbCol,
    mdbCardFooter,
    mdbBtn,
    mdbBadge,
    mdbMask,
    mdbView,
    mdbCardImage,
    EditPage,
    UserMaint
  },
  data() {
    return {
      affiliate: [],
      showMain: true,
      showPageEdit: false,
      showUserMaint: false
    }
  },
  computed: {
    userDetails() {
      return this.$store.state.userDetails
    },
    loggedIn() {
      return this.$store.state.loggedIn
    },
    showAdminButtons() {
      if (!this.affiliate || !this.affiliate.authority) return false
      if (this.affiliate.authority.editLandingPage || this.affiliate.authority.userMaint) return true
      return false
    }
  },
  mounted() {
    this.$store.dispatch("setExecuting", false)
    api.get("/affiliate/show/" + this.$route.params.id).then(
      (results) => {
        this.affiliate = results.data
        window.localStorage.setItem("affiliate", results.data.affiliateCode)
      },
      (error) => {
        if (error.response.status == 404) this.$router.push({path: '/404', query: {redirect: this.$route.fullPath}})
        else if (error.response.status == 403) this.$router.push({
                                                                   path: '/403',
                                                                   query: {redirect: this.$route.fullPath}
                                                                 })
        else this.$notify.error({message: "Error fetching page.", timeOut: 5000})
      }).then(() => {
      this.$store.dispatch("setExecuting", false)
    })
  },
  methods: {
    editPage() {
      this.showMain = false
      this.showPageEdit = true
    },
    userMaint() {
      this.showMain = false
      this.showUserMaint = true
    },
    pageSaved(newPage) {
      this.affiliate.homeHtml = newPage
      this.showPageEdit = false
      this.showMain = true
    },
    cancelEdit() {
      this.showPageEdit = false
      this.showMain = true
    },
    cancelUserMaint() {
      this.showUserMaint = false
      this.showMain = true
    }
  }
};
</script>
